<template>
    <DCard
        padding
    >
        <Form
            :transfer-settings="transferSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TransferSettings/Form'
export default {
    name: 'TransferSettingsCreate',
    components: { Form },
    props: {
        transferSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.transfer-settings.store'))
        }
    }
}
</script>

<style scoped>

</style>
